import React, { useState } from 'react';

import jwt_decode from 'jwt-decode';

const AuthContext = React.createContext();
const AuthConsumer = AuthContext.Consumer;

const AuthProvider = (props) => {
  const [isAuth, setIsAuth] = useState((function () {
    if (
      localStorage.getItem('isAuth') &&
      (Date.now() / 1000 <= jwt_decode(localStorage.getItem('token')).exp)
    ) {
      return true;
    } else {
      localStorage.removeItem('isAuth');
      localStorage.removeItem('token');
      localStorage.removeItem('userUUID');
      localStorage.removeItem('role');
      return false;
    }
  })());

  const [role, setRole] = useState(localStorage.getItem('role'));

  const signIn = () => {
    localStorage.setItem('isAuth', true);
    setRole(localStorage.getItem('role'));
    setIsAuth(true);
  }

  const signOut = () => {
    localStorage.removeItem('isAuth');
    localStorage.removeItem('token');
    localStorage.removeItem('userUUID');
    localStorage.removeItem('role');
    setIsAuth(false);
    window.history.go();
  }
  return (
    <AuthContext.Provider
      value={{ isAuth, signIn, signOut, role }}
    >
      {props.children}
    </AuthContext.Provider>
  )
}

export { AuthProvider, AuthConsumer, AuthContext }
